import { signUp, getCurrentSession } from '../../lib/authentication'

export const fetchAll = () => {
    return getCurrentSession().then(result => {
        const { idToken } = result;
        return apigClient.adminUsersGet({}, {}, {
            headers: {
                Authorization: idToken
            }
        });
    }).then(response => {
        return response.data.data.Items;
    });
};

export const inviteUser = (email, role, brokerageId, inviteUserId) => {
    let body = {
        email,
        role: role,
        broker_id: brokerageId,
        invite_user_id: inviteUserId
    };

    return apigClient.adminUsersPost({}, body, {}).then(response => {
        if (response.data.success === true) {
            return true;
        } else {
            const error = new Error(response.data.message);
            error.errorCode = response.data.errorCode;
            error.user = response.data.user;
            error.brokerId = response.data.brokerId;
            throw error;
        }
    });
};

export const saveUser = (id, firstName, lastName, title, phone, phoneExt, role) => {
    return getCurrentSession()
        .then(result => {
            const { idToken } = result;
            return apigClient.adminUsersIdPut(
                { id },
                [
                    { fieldName: 'firstName', fieldValue: firstName },
                    { fieldName: 'lastName', fieldValue: lastName },
                    { fieldName: 'title', fieldValue: title },
                    { fieldName: 'phone', fieldValue: phone },
                    { fieldName: 'phoneExt', fieldValue: phoneExt },
                    { fieldName: 'role', fieldValue: role }
                ],
                {
                    headers: {
                        Authorization: idToken
                    }
                }
            );
        }).then(response => {
            if (!response.data.success) {
                throw new Error(response.data.message);
            }
        });
};

export const updateStatus = (id, status) => {
    return getCurrentSession()
        .then(result => {
            const { idToken } = result;
            return apigClient.adminUsersIdPut(
                { id: id },
                [{ fieldName: 'status', fieldValue: status }],
                {
                    headers: {
                        Authorization: idToken
                    }
                }
            );
        }).then(response => {
            if (!response.data.success) {
                throw new Error(response.data.message);
            }
        });
};

export const updateBrokerage = (id, brokerId) => {
    return getCurrentSession()
        .then(result => {
            const { idToken } = result;
            return apigClient.adminUsersIdPut(
                { id: id },
                [{ fieldName: 'brokerId', fieldValue: brokerId }],
                {
                    headers: {
                        Authorization: idToken
                    }
                }
            );
        }).then(response => {
            if (!response.data.success) {
                throw new Error(response.data.message);
            }
        });
};

export const signupUser = username => signUp(username).then(status => status).catch(error => error)

export const requestAccess = userData => {
    const client = apigClientFactory.newClient();
    return client.usersRequestAccessPost({}, userData);
};
